import { useEffect, useMemo, useState } from "react"
import { useLocation, useNavigate } from "react-router-dom"
import { logout } from "../../auth"

import "./AdminNav.css"

function AdminNav({ menuOpen, setMenuOpen }) {
    const navigate = useNavigate()
    const location = useLocation()
    const [ selected, setSelected ] = useState(undefined)
    const [expandedMenu, setExpandedMenu] = useState(null)

    const routes = useMemo(() => [
        {
            name: 'Dashboard',
            className: 'dashboard',
            resource: 'dashboard',
            url: '/'
        },
        {
            name: 'Permissões',
            className: 'permissoes',
            resource: 'permissoes',
            url: '/admin/permissoes'
        },
        {
            name: 'Gerenciar Animais',
            className: 'animal-manage',
            childrens: [
                {
                    name: 'Consultar Metas',
                    className: 'animal-consult',
                    resource: 'consulta',
                    url: '/admin/animais/consulta'
                },
                {
                    name: 'Cadastrar Metas',
                    className: 'animal-create',
                    resource: 'cadastro',
                    url: '/admin/animais/cadastro'
                },
                {
                    name: 'Meta Flexivel',
                    className: 'meta-flexivel',
                    resource: 'meta-flexivel',
                    url: '/admin/animais/meta-flexivel'
                }
            ]
        },
        {
            name: 'Relatório de Metas',
            className: 'relatorio-metas',
            resource: 'relatorio-metas',
            url: '/admin/relatorio-metas'
        },
        {
            name: 'Painel de Bordo',
            className: 'painel-bordo',
            childrens: [
                {
                    name: 'Metas Serviços',
                    className: 'metas-servicos',
                    resource: 'metas-servicos',
                    url: '/admin/painel-bordo/metas-servicos'
                },
                {
                    name: 'Metas Dpto.',
                    className: 'metas-departamentos',
                    resource: 'metas-departamentos',
                    url: '/admin/painel-bordo/metas-departamentos'
                },
                {
                    name: 'Metas Gerais',
                    className: 'metas-gerais',
                    resource: 'metas-gerais',
                    url: '/admin/painel-bordo/metas-gerais'
                },
            ]
        },

        {
            name: 'Metas Extra',
            className: 'metas-extra',
            childrens:[
                {
                    name: 'Upload metas Extranet',
                    className: 'metas-extranet',
                    resource: 'metas-extranet',
                    url:'/admin/uploadMetasExtra/metas-extranet'
                },
                {
                    name: 'Gerenciar Metas Extra',
                    className: 'gerenciar-metas',
                    resource: 'gerenciar-metas',
                    url: '/admin/gerenciarMetasExtra/gerenciar' 
                },
                {
                    name: 'Meta Vendedor Global',
                    className: 'meta-vendedor-global',
                    resource: 'meta-vendedor-global',
                    url: '/admin/gerenciarMetasExtra/meta-vendedor-global'
                }

            ]

        },
        {
            name: 'Pontuação Geral',
            className: 'pontuacao-geral',
            resource: 'pontuacao-geral',
            url: '/admin/pontuacao-geral'
        },
        {
            name: 'Vendas Suricato',
            className: 'vendas-suricato',
            resource: 'vendas-suricato',
            url: '/admin/vendas-suricato'
        },
        {
            name: 'TRV',
            className: 'trv',
            childrens: [
                {
                    name: 'Gerenciar Cluster',
                    className: 'trv-cluster',
                    resource: 'gerenciamentocluster',
                    url: '/admin/trv/gerenciamentocluster'
                },
                {
                    name: 'Cadastrar Cluster',
                    className: 'trv-cluster',
                    resource: 'cadastrocluster',
                    url: '/admin/trv/cadastrocluster'
                }
            ]
        },
        {
            name: 'Habilitar Regiões',
            className: 'habilitar-regioes',
            resource: 'habilitar-regioes',
            url: 'habilitar-regioes'
        },
        
        {
            name: 'Quadrante',
            className:  'animal-manage trofeu-campeao',
            childrens: [
                {
                    name: 'Meta Mês Vend',
                    className: 'animal-consult',
                    resource: 'consulta',
                    url: '/admin/Quadrante/MetaMesVend'
                },
            ]
        },
        {
            name: 'Remuneração',
            className: 'remuneracao',
            childrens: [
                {
                    name: 'Vendedores',
                    className: 'trv-cluster',
                    resource: 'remuneracao-vendedores',
                    url: '/admin/remuneracao/vendedores'
                },
                {
                    name: 'Gerentes',
                    className: 'trv-cluster',
                    resource: 'gerentes',
                    url: '/admin/remuneracao/gerentes'
                },
                {
                    name: 'Saque Fácil',
                    className: 'saque-facil',
                    resource: 'saque-facil',
                    url: '/admin/saque-facil'
                },

            ]
        },
        {
            name: 'Cluster',
            className: 'listar-cluster',
            childrens: [
                {
                    name: 'Listar Clusters',
                    className: 'listarcluster',
                    resource: 'listarcluster',
                    url: '/admin/cluster/listarcluster'
                },
                {
                    name: 'Ger. Clusters',
                    className: 'gerenciarcluster',        
                    resource: 'gerenciarcluster',
                    url: '/admin/cluster/gerenciarcluster',
                }
            ]
        },
        {
            name: 'Índices de Projeção',
            className: 'indices-projecao',
            childrens: [
                {
                    name: 'Importar Índices',
                    className: 'importacao',
                    resource: 'importacao',
                    url: '/admin/indiceprojecao/importacao'
                },
                {
                    name: 'Gerenciar Índices',
                    className: 'gerenciamento',
                    resource: 'gerenciamento',
                    url: '/admin/indiceprojecao/gerenciamento'
                }

            ]
        },
        {
            name: 'Quadro Vendedores',
            className: 'quadro-vendedores',
            childrens: [
                {
                    name: 'Importar Quadro',
                    className: 'importacao',
                    resource: 'importacao',
                    url: '/admin/quadro-vendedores/importacao'
                },
                {
                    name: 'Listar Quadro',
                    className: 'listar',
                    resource: 'listar',
                    url: '/admin/quadro-vendedores/listar'
                }
            ]
        },
        {
            name: 'Logout',
            className: 'logout',
            resource: 'logout',
            url: '/login'
        },
    ], [])

    useEffect(() => {
        const activeParent = routes.find(route =>
            route.childrens?.some(childrenRoute =>
                location.pathname === childrenRoute.url
                || location.pathname.startsWith(`${childrenRoute.url}/`)
            )
        )
        const activeChildren = activeParent?.childrens.find(childrenRoute =>
            location.pathname === childrenRoute.url
            || location.pathname.startsWith(`${childrenRoute.url}/`)
        )
        const activeRoute = activeChildren || routes.find(route => route.url === location.pathname)
        const splittedUrl = location.pathname.split('/')
        const urlResource = splittedUrl[splittedUrl.length-1]

        setSelected(activeRoute?.resource || urlResource)

        setExpandedMenu(activeParent?.name || null)
    }, [location.pathname, routes])

    function handleRouteChoose(resource, url) {
        if(resource === 'logout')
            logout()
        setSelected(resource)
        navigate(url)
        
        if (window.innerWidth <= 768) {
            setMenuOpen(false);
        }
    }

    function handleParentClick(routeName) {
        setExpandedMenu(prev => prev === routeName ? null : routeName)
    }

    
    return (
        <nav id="admin-nav" className={menuOpen ? "open" : "closed"}>
            <ul>
                {routes.map(route => (
                    route?.childrens 
                        ?   <li key={route.name}
                                className={`${route.className} ${expandedMenu === route.name ? 'expanded' : ''}`}
                                onClick={() => handleParentClick(route.name)} 
                            >
                                <span>{route.name}</span>
                                <ul className="sub-ul" style={{ display: expandedMenu === route.name ? 'block' : 'none' }}>
                                    {route.childrens.map(childrenRoute => (
                                        <li key={childrenRoute.name} 
                                            className={`${childrenRoute.className} ${childrenRoute.resource === selected ? 'active' : ''}`}
                                            onClick={(e) => { 
                                                e.stopPropagation()
                                                handleRouteChoose(childrenRoute.resource, childrenRoute.url)}
                                            }
                                        >
                                            <span>{childrenRoute.name}</span>
                                        </li>
                                    ))}
                                </ul>
                            </li>
                        :   <li key={route.name}
                                className={`${route.className} ${route.resource === selected ? 'active' : ''}`}
                                onClick={() => handleRouteChoose(route.resource, route.url)}
                            >
                                <span>{route.name}</span>
                            </li>
                ))}
            </ul>
        </nav>
    )
}

export default AdminNav
